import {
    debounce,
    preventScroll,
    viewportSmall,
    viewportMedium,
    viewportLarge,
    watchMedia,
    isClickOutside,
    isMobile
} from "../../../_modules/helpers";

export default () => {
    const header = document.getElementById("page-header");
    const headerBurgerOpen = document.getElementById("open-menu");
    const headerBurgerClose = document.getElementById("close-menu");
    const headerContainer = document.querySelector(".js-header-container");
    const headerContainerClose = document.querySelector(
        ".js-header-container-close"
    );
    const headerServicesList = document.querySelector(
        ".js-header-services-list"
    );
    const headerServicesListContainer = document.querySelector(
        ".js-header-services-list-container"
    );
    const headerServicesListArrow = document.querySelector(
        ".js-header-services-list-arrow"
    );
    let width = document.documentElement.clientWidth;

    const headerDropdownToggle = document.getElementById(
        "header-dropdown-toggle"
    );
    const headerDropdownDecoy = document.getElementById(
        "header-dropdown-decoy"
    );
    const headerDropdownContent = document.querySelector(
        '#header-dropdown-toggle ~ [aria-labelledby="header-dropdown-toggle"]'
    );

    const focustrapFirstMedium = document.querySelector(
        '[data-focustrap-first*="m"]'
    );
    const focustrapLastMedium = document.querySelector(
        '[data-focustrap-last*="m"]'
    );
    const focustrapFirstSmall = document.querySelector(
        '[data-focustrap-first*="s"]'
    );
    const focustrapLastSmall = document.querySelector(
        '[data-focustrap-last*="s"]'
    );

    let focustrapFirst = null;
    let focustrapLast = null;
    let elementToFocusOnMenuOpening = null;
    let restoreScroll = null;

    let toggleDropdownBtn = document.querySelectorAll(
        ".js-toggle-dropdown-btn"
    );
    let toggleDropdownContainerAll = document.querySelectorAll(
        ".js-toggle-dropdown-container"
    );

    headerServicesList.addEventListener("click", () => {
        headerServicesListContainer.classList.toggle(
            "header__side-container-links-item-bottom--hide"
        );
        headerServicesListArrow.classList.toggle(
            "header__side-container-links-item-arrow--show"
        );
    });

    toggleDropdownBtn.forEach(elem => {
        elem.classList.remove("dropdown__toggle--rotate");
        elem.addEventListener("click", event => {
            event.stopPropagation();
            let toggleDropdownContainer = elem.parentNode.querySelector(
                ".dropdown__content"
            );
            if (!toggleDropdownContainer) {
                console.error("toggleDropdownContainer не найден");
                return;
            }
            // Закрыть все открытые контейнеры
            toggleDropdownContainerAll.forEach(container => {
                if (container !== toggleDropdownContainer) {
                    container.classList.add("dropdown__content--hide");
                }
            });
            // Открыть или закрыть текущий контейнер
            if (
                toggleDropdownContainer.classList.contains(
                    "dropdown__content--hide"
                )
            ) {
                toggleDropdownContainer.classList.remove(
                    "dropdown__content--hide"
                );
                elem.classList.add("dropdown__toggle--rotate");
            } else {
                toggleDropdownContainer.classList.add(
                    "dropdown__content--hide"
                );
                elem.classList.remove("dropdown__toggle--rotate");
            }
            // Удалить класс dropdown__toggle--rotate с других кнопок
            toggleDropdownBtn.forEach(button => {
                if (button !== elem) {
                    button.classList.remove("dropdown__toggle--rotate");
                }
            });
        });
    });

    const manageStickyHeader = debounce(e => {
        const becameSticky =
            e.target.documentElement.scrollTop > 0 ||
            document.documentElement.style.position === "fixed";
        if (!isMobile) header.classList.toggle("header--sticky", becameSticky);
    }, 100);

    document.addEventListener("click", function(event) {
        if (
            !event.target.classList.contains("toggleDropdownBtn") &&
            !event.target.classList.contains("dropdown__content") &&
            !event.target.classList.contains("dropdown__section") &&
            !event.target.classList.contains("dropdown__ul") &&
            !event.target.classList.contains("dropdown__ul-li")
        ) {
            // Закрыть все контейнеры
            toggleDropdownContainerAll.forEach(container => {
                container.classList.add("dropdown__content--hide");
            });
            // Удалить класс dropdown__toggle--rotate у всех кнопок
            toggleDropdownBtn.forEach(button => {
                button.classList.remove("dropdown__toggle--rotate");
            });
        }
    });

    // turns dropdown into just regular content

    // burger menu logic
    const openMenu = () => {
        headerContainer.classList.add("header__side-container--show");
        document.body.style.overflow = "hidden";
    };

    const closeMenu = () => {
        headerContainer.classList.remove("header__side-container--show");
        document.body.style.overflow = "initial";
    };

    const bannerButtons = document.querySelectorAll("[data-buttonhf]");
    const DIFF_HEIGHT = 48; // difference between open banner and hidden

    const scrollToCalc = bannerButton => {
        const elemScrollTo = document
            .getElementsByClassName("calculator")[0]
            .getBoundingClientRect().top;
        const offsetForScroll =
            elemScrollTo - bannerButton.offsetHeight - DIFF_HEIGHT;
        window.scrollBy({
            top: offsetForScroll,
            behavior: "smooth"
        });
    };
    bannerButtons.forEach(bannerButton =>
        bannerButton.addEventListener("click", () => scrollToCalc(bannerButton))
    );

    // needed for correct tab order in burger menu
    const recalculateTabindicies = size => {
        const elementsToInspect = Array.from(
            document.querySelectorAll("[data-tabindex]")
        );
        const model = elementsToInspect.map(elem => {
            const result = { elem };
            const tabIndiciesTuple = elem.dataset.tabindex.split(" ");
            if (tabIndiciesTuple[0] !== "0")
                result.tabIndexLarge = tabIndiciesTuple[0];
            if (tabIndiciesTuple[1] !== "0")
                result.tabIndexMedium = tabIndiciesTuple[1];
            if (tabIndiciesTuple[2] !== "0")
                result.tabIndexSmall = tabIndiciesTuple[2];
            return result;
        });

        model.forEach(desc => {
            const elem = desc.elem;
            elem.removeAttribute("tabindex");

            if (size === "large" && desc.tabIndexLarge) {
                elem.setAttribute("tabindex", desc.tabIndexLarge);
                if (desc.tabIndexLarge === "1")
                    elementToFocusOnMenuOpening = elem;
            } else if (size === "medium" && desc.tabIndexMedium) {
                elem.setAttribute("tabindex", desc.tabIndexMedium);
                if (desc.tabIndexMedium === "1")
                    elementToFocusOnMenuOpening = elem;
            } else if (size === "small" && desc.tabIndexSmall) {
                elem.setAttribute("tabindex", desc.tabIndexSmall);
                if (desc.tabIndexSmall === "1")
                    elementToFocusOnMenuOpening = elem;
            }
        });
    };

    window.addEventListener("scroll", manageStickyHeader);
    window.addEventListener("load", manageStickyHeader);
    window.addEventListener("resize", () => {
        width = document.documentElement.clientWidth;
        if (width > 1140) {
            closeMenu();
        }
    });

    const getIsBurgerMenuOpened = () =>
        header.getAttribute("aria-expanded") === "true";

    const manageKeyDown = e => {
        const isTab = e.code === "Tab" && !e.shiftKey;
        const isShiftTab = e.code === "Tab" && e.shiftKey;
        const isEsc = e.code === "Escape";

        const isBurgerMenuOpened = getIsBurgerMenuOpened();
        if (!isBurgerMenuOpened) return;

        const isFirstElementInFocus = document.activeElement === focustrapFirst;
        const isLastElementInFocus = document.activeElement === focustrapLast;

        if (isEsc) closeMenu();
        else if (isTab && isLastElementInFocus) focustrapFirst.focus();
        else if (isShiftTab && isFirstElementInFocus) focustrapLast.focus();
        if (
            isEsc ||
            (isTab && isLastElementInFocus) ||
            (isShiftTab && isFirstElementInFocus)
        )
            e.preventDefault();
    };

    if (headerBurgerOpen && headerContainerClose) {
        headerBurgerOpen.addEventListener("click", openMenu);
        headerContainerClose.addEventListener("click", closeMenu);
    }

    // recalculate things on viewport width change
    const unwatchMQLarge = watchMedia(viewportLarge, () => {
        recalculateTabindicies("large");
        closeMenu();
    });

    const unwatchMQMedium = watchMedia(viewportMedium, () => {
        recalculateTabindicies("medium");
        focustrapFirst = focustrapFirstMedium;
        focustrapLast = focustrapLastMedium;
    });

    const unwatchMQSmall = watchMedia(viewportSmall, () => {
        recalculateTabindicies("small");
        focustrapFirst = focustrapFirstSmall;
        focustrapLast = focustrapLastSmall;
    });

    window.addEventListener("keydown", manageKeyDown);

    return () => {
        if (headerBurgerOpen && headerContainerClose) {
            headerBurgerOpen.removeEventListener("click", openMenu);
            headerContainerClose.removeEventListener("click", closeMenu);
        }

        window.removeEventListener("scroll", manageStickyHeader);
        window.removeEventListener("load", manageStickyHeader);

        unwatchMQLarge();
        unwatchMQMedium();
        unwatchMQSmall();
    };
};
